export default {
  fields: {
    online_shop_domain: 'Eget domæne til onlineshoppen',
    online_shop_domain_hint:
      'Et domæne, restauranten ejer, f.eks. order.pizzeria-mario.com – kun til bestilling; en hjemmeside kræver et andet. Når det er gemt, vises de records, der skal tilføjes, her.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
